import appTheme from "../theme";
import { alpha } from "@mui/material/styles";
import { common } from "@mui/material/colors";
import { red, blue, green } from "@mui/material/colors";
import {
  BookingStatus,
  RentContractStatus,
} from "src/common_constants/EnumsConstants/Booking";

declare module "@mui/material/styles" {
  interface Palette {
    bookingStatus: {
      [key in BookingStatus]: string;
    };
    rentContractStatus: {
      [key in RentContractStatus]: string;
    };
  }
  interface PaletteOptions {
    bookingStatus?: {
      [key in BookingStatus]?: string;
    };
    rentContractStatus?: {
      [key in RentContractStatus]?: string;
    };
  }
}

const neutral = {
  50: "#F8F9FA",
  100: "#F3F4F6",
  200: "#E6F0F9",
  300: "#D2D6DB",
  400: "#9DA4AE",
  500: "#5e6c84",
  600: "#6C737F",
  700: "#4D5761",
  800: "#2F3746",
  900: "#111927",
};

const customColors = {
  customColor1: red[500],
  customColor2: blue[500],
  customColor3: green[500],
};

const colorPalette = {
  primary: {
    light: "#06afe3",
    main: "#1159a3",
    dark: "#0c4a8a",
    contrastText: "#fff",
  },
  secondary: {
    light: "#ff9800",
    main: "#FF5733",
    dark: "#e65100",
    contrastText: "#fff",
  },
  custom: customColors,
  neutral,
  text: {
    primary: neutral[900],
    secondary: neutral[500],
    disabled: alpha(neutral[900], 0.38),
  },
  action: {
    active: neutral[500],
    disabled: alpha(neutral[900], 0.38),
    disabledBackground: alpha(neutral[900], 0.12),
    focus: alpha(neutral[900], 0.16),
    hover: alpha(neutral[900], 0.04),
    selected: alpha(neutral[900], 0.12),
  },
  background: {
    default: common.white,
    paper: "#feffff",
  },
  success: {
    main: "#4caf50",
    light: "#2e7d32",
    dark: "#1b5e20",
    contrastText: "#fff",
  },
  error: {
    main: "#ef5350",
    light: "#d32f2f",
    dark: "#c62828",
    contrastText: "#fff",
  },
  warning: {
    main: "#ff9800",
    light: "#ed6c02",
    dark: "#e65100",
    contrastText: "#fff",
  },

  bookingStatus: {
    [BookingStatus.New]: "#2196f3",
    [BookingStatus.Quote]: "#8e24aa",
    [BookingStatus.Reserved]: "#f57c00",
    [BookingStatus.ContractCreated]: "#ffeb3b",
    [BookingStatus.Confirm]: "#4caf50",
    [BookingStatus.ContractSigned]: "#1976d2",
    [BookingStatus.CheckedOut]: "#d32f2f",
    [BookingStatus.Completed]: "#4caf50",
    [BookingStatus.Cancelled]: "#f44336",
    [BookingStatus.NoShow]: "#9e9e9e",
    [BookingStatus.PaymentPending]: "#ff9800",
    [BookingStatus.Void]: "#607d8b",
  },
  rentContractStatus: {
    [RentContractStatus.New]: "#2196f3",
    [RentContractStatus.Active]: "#4caf50",
    [RentContractStatus.Completed]: "#8bc34a",
    [RentContractStatus.Terminated]: "#f44336",
    [RentContractStatus.Void]: "#9e9e9e",
  },
};

var theme = appTheme(
  colorPalette.primary.main,
  colorPalette.primary.contrastText,
  colorPalette
);

const lightTheme = {
  ...theme,
  palette: {
    mode: "light",
    ...colorPalette,
  },
};
export default lightTheme;
